<template>
  <v-layout row justify-center class="mt-5">
    <v-flex sm11 md7 lg5>
      <v-card>
        <v-card-title primary-title>
          <v-flex class="text-center">
            <h3 class="display-1">Gritus Franchisee Dashboard</h3>
          </v-flex>
        </v-card-title>
        <v-card-text>
          <v-alert v-if ="errorMsg" type="error" :value="errorMsg" transition="fade-transition">{{ errorMsg }}</v-alert>
          <form @submit.prevent>
            <v-text-field :label="$t('user.email')" v-model="form.email" required></v-text-field>
            <v-text-field
              :label="$t('user.password')"
              type="password"
              v-model="form.password"
              required
            ></v-text-field>
            <v-flex class="text-center">
              <v-btn
                color="primary"
                type="submit"
                :loading="loading"
                @click="submit"
              >{{ $t('user.login') }}</v-btn>
            </v-flex>
          </form>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import _ from 'lodash'

import authService from '@/services/auth'
import userService from '@/services/user'

export default {
  data () {
    return {
      loading: false,

      errorMsg: '',

      form: {
        email: null,
        password: null
      }
    }
  },

  methods: {
    async submit () {
      this.errorMsg = ''
      this.loading = true

      try {
        let { headers, data } = await authService.login(this.form)

        if (data.status === 'success') {
          this.$store.commit('SET_TOKEN', headers.authorization.split(' ')[1])
          this.$store.commit('SET_SMOOCH_TOKEN', data.data.smooch_token)

          // Get franchisee's data
          let userData = await userService.getDetails()
          this.$store.commit('SET_USER_DATA', _.omit(userData.data.data, ['data']))
          this.$store.commit('SET_LOCATIONS_DATA', userData.data.data.data || {})
          this.$store.commit('SET_MACHINES_DATA', userData.data.data.franchisee_machines || {})

          if (userData.data.data) {
            this.$router.replace('/home')
          } else {
            throw new Error(data.message)
          }
        } else {
          throw new Error(data.message)
        }
      } catch (error) {
        let errorMsg = _.get(error, 'response.data.message', this.$t('error_message'))
        this.errorMsg = errorMsg === 'Invalid Credentials' ? this.$t('user.invalid_credentials') : errorMsg
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
